import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=f4512aea&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=f4512aea&prod&lang=scss&scoped=true&"
import style1 from "./Header.vue?vue&type=style&index=1&id=f4512aea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4512aea",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconArrowLeft: require('/opt/build/repo/components/icons/IconArrowLeft.vue').default,LanguageToggle: require('/opt/build/repo/components/common/LanguageToggle.vue').default,IconInbox: require('/opt/build/repo/components/icons/IconInbox.vue').default,IconInboxWhite: require('/opt/build/repo/components/icons/IconInboxWhite.vue').default,IconUser: require('/opt/build/repo/components/icons/IconUser.vue').default,IconUserWhite: require('/opt/build/repo/components/icons/IconUserWhite.vue').default,IconMarker: require('/opt/build/repo/components/icons/IconMarker.vue').default,IconChevronDown: require('/opt/build/repo/components/icons/IconChevronDown.vue').default,IconBoBox: require('/opt/build/repo/components/icons/IconBoBox.vue').default,IconHamburger: require('/opt/build/repo/components/icons/IconHamburger.vue').default,IconCloseMenu: require('/opt/build/repo/components/icons/IconCloseMenu.vue').default,MobileMenu: require('/opt/build/repo/components/layout/MobileMenu.vue').default,Header: require('/opt/build/repo/components/layout/Header.vue').default})
